export const POST_CHECKOUT_SURVEY_OPTIONS = [
  { value: "friend-or-family-member", component: "default" },
  { value: "vet", component: "default" },
  { value: "breeder", component: "default" },
  { value: "someone-i-follow-on-social-media", component: "default" },
  { value: "facebook-ad", component: "default" },
  { value: "facebook-group", component: "default" },
  { value: "instagram-ad", component: "default" },
  { value: "tiktok-ad", component: "default" },
  { value: "google-ad", component: "default" },
  { value: "katkin-popup-stand", component: "default" },
  { value: "a-flyer-i-received-in-a-parcel", component: "default" },
  { value: "tv", component: "default" },
];

export const OTHER_OPTION = { value: "other", component: "default" };
